import { render, staticRenderFns } from "./ResendCode.vue?vue&type=template&id=4fa0c09b&"
import script from "./ResendCode.vue?vue&type=script&lang=js&"
export * from "./ResendCode.vue?vue&type=script&lang=js&"
import style0 from "./ResendCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports